/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { DeletePropertyMutationResponse } from "../../types/DeleteProperty.ts";
import { http } from "msw";

export function deletePropertyHandler(data?: DeletePropertyMutationResponse | ((
          info: Parameters<Parameters<typeof http.delete>[1]>[0],
        ) => Response)) {
  return http.delete('http://localhost:3000/api/v1/property/:id', function handler(info) {
      if(typeof data === 'function') return data(info)
  
      return new Response(JSON.stringify(data), {
        status: 204,
        
      })
    })
}